import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  GrueMaterialItemData,
  initialGrueMaterialPageState,
} from "../core/_model.grue";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedGrueMaterial = {
  data: GrueMaterialItemData | null;
  action: ActionsKey;
};

type GrueMaterialDataType = {
  grueMaterialList: any;
  detail: GrueMaterialItemData | null;
  actioned: ActionedGrueMaterial | null;
  totalItems?: number;
  setDetail: (detail: GrueMaterialItemData | null) => void;
  setGrueMaterialList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedGrueMaterial | null) => void;
};

export const useGrueMaterialStore = create<GrueMaterialDataType>((set) => ({
  grueMaterialList: [],
  detail: null,
  actioned: null,
  totalItems: 0,
  defaultPagination: {
    page: 1,
    itemsPerPage: 10,
  },
  setDetail: (detail) => set((state) => ({ detail })),
  setGrueMaterialList: (saleData) =>
    set((state) => ({
      grueMaterialList: saleData?.member,
      totalItems: saleData?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useGrueMaterialListState = create<DefaultListStateType>((set) => ({
  pageState: initialGrueMaterialPageState,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: {
        page: 1,
        itemsPerPage: 10,
      },
    })),
}));
